<ng-container *ngIf="form" [formGroup]="form">
  <div class="cont-selector">
    <div class="select-container" *ngIf="!oneDocument">
      <label class="title">{{'BOOKING_MODULE.DOCUMENT' | transloco}}</label>
      <app-dropdown-select
        #typeSelector
        [fullWidth]="true"
        [defaultOption]="defaultDocument"
        [selectOptions]="documentTags"
        [title]="'BOOKING_MODULE.DOCUMENT'|  transloco"
        [showError]="documentError"
        [scrollFixedPosition]="false"
        [manipulateDOM]="false"
        [isMobile]="isMobile"
        (selected)="onDocumentTypeSelected($event)">
      </app-dropdown-select>
    </div>
    <fieldset class="input" [class.full-width]="oneDocument">
      <label class="documentNumber" *ngIf="oneDocument">{{label}}</label>
      <ng-container *ngTemplateOutlet="documentInputBody"></ng-container>
    </fieldset>
  </div>
</ng-container>

<ng-template #documentInputBody>
  <ng-container *ngIf="isPaxValues">
    <div #paxInput>
      <app-form-text-input
        [form]="form"
        [formControlSelector]="documentNumberSelector"
        [documentCustomErrors]="documentCustomErrors"
        [id]="documentNumberSelector"
        [maxLength]="paxValidators?.MAX_LENGTH"
        [isSubmitted]="isSubmitted"
        [formInputType]="documentInput"
        [inputDocumentType]="paxValidators?.FORM_INPUT"
        [hasInternationalDocumentError]="showInternationalDocumentError"
        [hiddenPlaceholder]="hiddenPlaceholder"
        [placeholder]="placeholderNumber | transloco"
        [style]="marginStyle"
        (click)="scroll(paxInputRef)">
      </app-form-text-input>
    </div>
  </ng-container>
  <ng-container *ngIf="isBillingValues">
    <div #billingInput>
      <app-form-text-input
        [form]="form"
        [formControlSelector]="documentNumberSelector"
        [documentCustomErrors]="documentCustomErrors"
        [id]="documentNumberSelector"
        [maxLength]="billingValidators?.MAX_LENGTH"
        [isSubmitted]="isSubmitted"
        [formInputType]="documentInput"
        [inputDocumentType]="billingValidators?.FORM_INPUT"
        [hasInternationalDocumentError]="showInternationalDocumentError"
        [hiddenPlaceholder]="hiddenPlaceholder"
        [placeholder]="placeholderNumber | transloco"
        [style]="marginStyle"
        (click)="scroll(billingInputRef)">
      </app-form-text-input>
    </div>
  </ng-container>
</ng-template>
